import { render, staticRenderFns } from "./FlowLists.vue?vue&type=template&id=65e047f4&scoped=true"
import script from "./FlowLists.vue?vue&type=script&lang=js"
export * from "./FlowLists.vue?vue&type=script&lang=js"
import style0 from "./FlowLists.vue?vue&type=style&index=0&id=65e047f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e047f4",
  null
  
)

export default component.exports